import { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios';
import { checkRequired, FieldError, Req, ERROR_COLOR } from '../../utils/formErrors';

const INPUT = { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '0.88rem', color: '#1e293b' };
const LABEL = { display: 'block', fontSize: '0.82rem', fontWeight: 600, color: '#374151', marginBottom: '5px' };

export default function ChangePasswordModal({ open, onClose }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  if (!open) return null;

  const reset = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setErrors({});
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const found = checkRequired({ currentPassword, newPassword, confirmPassword }, {
      currentPassword: 'Mot de passe actuel', newPassword: 'Nouveau mot de passe', confirmPassword: 'Confirmer le nouveau mot de passe',
    });
    if (!found.newPassword && newPassword.length < 6) found.newPassword = 'Le nouveau mot de passe doit contenir au moins 6 caractères.';
    if (!found.confirmPassword && newPassword !== confirmPassword) found.confirmPassword = 'Les mots de passe ne correspondent pas.';
    setErrors(found);
    if (Object.keys(found).length) return;
    setSaving(true);
    try {
      await api.post('/auth/users/me/change-password/', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success('Mot de passe modifié avec succès.');
      handleClose();
    } catch (err) {
      const message = err.response?.data?.error || 'Erreur lors du changement de mot de passe.';
      // Erreur la plus fréquente : mot de passe actuel incorrect → affichée sous ce champ
      if (err.response?.status === 400) setErrors({ currentPassword: message });
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '20px' }}
      onClick={handleClose}
    >
      <div
        style={{ background: 'white', borderRadius: '16px', padding: '28px', maxWidth: '380px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.22)' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ fontWeight: 800, fontSize: '1.05rem', color: '#1e293b', marginBottom: '18px' }}>
          Changer mon mot de passe
        </div>
        <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
          <div>
            <label style={LABEL}>Mot de passe actuel<Req /></label>
            <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} style={{ ...INPUT, ...(errors.currentPassword ? { borderColor: ERROR_COLOR } : {}) }} autoFocus />
            <FieldError message={errors.currentPassword} />
          </div>
          <div>
            <label style={LABEL}>Nouveau mot de passe<Req /></label>
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={{ ...INPUT, ...(errors.newPassword ? { borderColor: ERROR_COLOR } : {}) }} />
            <FieldError message={errors.newPassword} />
          </div>
          <div>
            <label style={LABEL}>Confirmer le nouveau mot de passe<Req /></label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={{ ...INPUT, ...(errors.confirmPassword ? { borderColor: ERROR_COLOR } : {}) }} />
            <FieldError message={errors.confirmPassword} />
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '6px' }}>
            <button type="button" onClick={handleClose}
              style={{ padding: '9px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', background: '#f8fafc', color: '#374151', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}>
              Annuler
            </button>
            <button type="submit" disabled={saving}
              style={{ padding: '9px 20px', borderRadius: '8px', border: 'none', background: '#1e40af', color: 'white', cursor: 'pointer', fontWeight: 700, fontSize: '0.9rem', opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Enregistrement...' : 'Changer le mot de passe'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
